import { createContext } from 'react';

import { MappingModalContextType, Nullable } from '@/types';

export const MappingModalContext = createContext<Nullable<MappingModalContextType>>(null);
